// src/public/rsvp/parts/RulesAccordion.jsx
import React, { useMemo } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Icon from '@mui/material/Icon';
import { alpha } from '@mui/material/styles';

import MDTypography from 'components/MDTypography';
import MDBox from 'components/MDBox';
import { compactAccordionSx, compactTitleSx } from './rsvpCompactSx';

function asRulesArray(v) {
  if (!v) return [];
  if (Array.isArray(v)) return v;
  if (typeof v === 'string') return [v];
  return [];
}

function fmtTRDateTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('tr-TR');
}

function RuleRow({ text, index }) {
  return (
    <MDBox
      sx={(t) => ({
        display: 'grid',
        gridTemplateColumns: '18px 1fr',
        gap: 0.75,
        alignItems: 'flex-start',
        px: 0.75,
        py: 0.6,
        borderRadius: 6,
        border: `1px solid ${
          t.palette.mode === 'dark'
            ? alpha(t.palette.common.white, 0.08)
            : alpha(t.palette.common.black, 0.06)
        }`,
        background:
          t.palette.mode === 'dark'
            ? alpha(t.palette.common.white, 0.03)
            : alpha(t.palette.common.black, 0.02),
      })}
    >
      {/* küçük nokta */}
      <MDBox
        sx={(t) => ({
          width: 8,
          height: 8,
          borderRadius: 2,
          mt: '4px',
          background: t.palette.mode === 'dark' ? alpha('#c7a56a', 0.55) : alpha('#b17c21', 0.45),
        })}
      />
      <MDTypography
        sx={{
          fontSize: 12.5,
          lineHeight: 1.25,
          opacity: 0.86,
          '& b': { fontWeight: 900 },
          wordBreak: 'break-word',
        }}
      >
        {text}
      </MDTypography>
    </MDBox>
  );
}

export function RulesAccordion({ companyRules }) {
  const rules = useMemo(
    () => asRulesArray(companyRules?.attendanceRules),
    [companyRules?.attendanceRules]
  );

  const updatedText = useMemo(
    () => fmtTRDateTime(companyRules?.attendanceRulesUpdatedAt),
    [companyRules?.attendanceRulesUpdatedAt]
  );

  return (
    <Accordion sx={compactAccordionSx}>
      <AccordionSummary expandIcon={<Icon sx={{ fontSize: 18 }}>expand_more</Icon>}>
        <MDBox sx={{ minWidth: 0, lineHeight: 1.15 }}>
          <MDTypography sx={compactTitleSx}>İşletme Kuralları</MDTypography>
          {updatedText ? (
            <MDTypography variant="caption" sx={{ opacity: 0.65, mt: 0.2 }} noWrap>
              Güncelleme: {updatedText}
            </MDTypography>
          ) : null}
        </MDBox>
      </AccordionSummary>

      <AccordionDetails>
        {rules.length === 0 ? (
          <MDTypography sx={{ fontSize: 12.5, opacity: 0.72 }}>—</MDTypography>
        ) : (
          <MDBox display="grid" gap={0.5}>
            {rules.map((r, idx) => (
              <RuleRow key={idx} index={idx} text={typeof r === 'string' ? r : JSON.stringify(r)} />
            ))}
          </MDBox>
        )}
      </AccordionDetails>
    </Accordion>
  );
}
